import {sweetAPI} from 'app/store/sweet-api';
import {providesTagsByURL, showLoadingBar} from 'app/store/sweet-api/utils';
import {REFERRALS_CODES_API_URL, REFERRALS_REFERRALS_API_URL} from 'app/urls';
import {REFERRALS_TAGS} from 'app/utils/rtk-tags';

import type {
  ListResponseType,
  ReferralSerializedType,
  WebinarCodeSerializedType,
} from 'sweet-types';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({
    addTagTypes: [REFERRALS_TAGS.CODES],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getCodes: build.query<ListResponseType<WebinarCodeSerializedType>, void>({
        query: () => ({
          url: REFERRALS_CODES_API_URL,
        }),
        onQueryStarted: showLoadingBar,
        providesTags: providesTagsByURL(REFERRALS_TAGS.CODES),
      }),
      getReferrals: build.query<ListResponseType<ReferralSerializedType>, void>(
        {
          query: () => ({
            url: REFERRALS_REFERRALS_API_URL,
          }),
          onQueryStarted: showLoadingBar,
          providesTags: providesTagsByURL(REFERRALS_TAGS.REFERRALS),
        }
      ),
    }),
  });

export const {useGetCodesQuery: useCodes, useGetReferralsQuery: useReferrals} =
  extendedAPI;
